import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frI18n from './locales/fr/i18n.json';
import enI18n from './locales/en/i18n.json';
import nlI18n from './locales/nl/i18n.json';
import deI18n from './locales/de/i18n.json';

import frAuth from './locales/fr/auth.json';
import enAuth from './locales/en/auth.json';
import nlAuth from './locales/nl/auth.json';
import deAuth from './locales/de/auth.json';

import frCommon from './locales/fr/common.json';
import enCommon from './locales/en/common.json';
import nlCommon from './locales/nl/common.json';
import deCommon from './locales/de/common.json';

import frNav from './locales/fr/nav.json';
import enNav from './locales/en/nav.json';
import nlNav from './locales/nl/nav.json';
import deNav from './locales/de/nav.json';

import frScreens from './locales/fr/screens.json';
import enScreens from './locales/en/screens.json';
import nlScreens from './locales/nl/screens.json';
import deScreens from './locales/de/screens.json';

import frParams from './locales/fr/params.json';
import enParams from './locales/en/params.json';
import nlParams from './locales/nl/params.json';
import deParams from './locales/de/params.json';

import frVoyageur from './locales/fr/voyageur.json';
import enVoyageur from './locales/en/voyageur.json';
import nlVoyageur from './locales/nl/voyageur.json';
import deVoyageur from './locales/de/voyageur.json';

import frFormulaires from './locales/fr/formulaires.json';
import enFormulaires from './locales/en/formulaires.json';
import nlFormulaires from './locales/nl/formulaires.json';
import deFormulaires from './locales/de/formulaires.json';

import frFormulairesPays from './locales/fr/formulaires_pays.json';
import enFormulairesPays from './locales/en/formulaires_pays.json';
import nlFormulairesPays from './locales/nl/formulaires_pays.json';
import deFormulairesPays from './locales/de/formulaires_pays.json';

export const SUPPORTED_LANGUAGES = ['fr', 'en', 'nl', 'de'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'fr';

// Clé partagée avec le site marketing (be-traveling.com) pour cohérence cross-domaine
// si jamais l'app et le site finissent sur le même domaine.
export const LANG_STORAGE_KEY = 'betraveling_lang';

const resources = {
  fr: { i18n: frI18n, auth: frAuth, common: frCommon, nav: frNav, screens: frScreens, params: frParams, voyageur: frVoyageur, formulaires: frFormulaires, formulaires_pays: frFormulairesPays },
  en: { i18n: enI18n, auth: enAuth, common: enCommon, nav: enNav, screens: enScreens, params: enParams, voyageur: enVoyageur, formulaires: enFormulaires, formulaires_pays: enFormulairesPays },
  nl: { i18n: nlI18n, auth: nlAuth, common: nlCommon, nav: nlNav, screens: nlScreens, params: nlParams, voyageur: nlVoyageur, formulaires: nlFormulaires, formulaires_pays: nlFormulairesPays },
  de: { i18n: deI18n, auth: deAuth, common: deCommon, nav: deNav, screens: deScreens, params: deParams, voyageur: deVoyageur, formulaires: deFormulaires, formulaires_pays: deFormulairesPays },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    defaultNS: 'common',
    ns: ['i18n', 'auth', 'common', 'nav', 'screens', 'params', 'voyageur', 'formulaires', 'formulaires_pays'],
    interpolation: { escapeValue: false },
    detection: {
      // Ordre : segment d'URL > localStorage > navigateur > fallback FR
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
  });

// Synchronise <html lang="..."> avec la langue active.
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
};
syncHtmlLang(i18n.language || DEFAULT_LANGUAGE);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
